import { render, staticRenderFns } from "./EmpresaUpdate.vue?vue&type=template&id=07e5196f&"
import script from "./EmpresaUpdate.vue?vue&type=script&lang=js&"
export * from "./EmpresaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports